module.exports = "<svg height=\"1em\" width=\"1em\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 31.44 31.44\"><path d=\"M1.12 16.84c-.62 0-1.1-.5-1.1-1.13 0-.6.48-1.1 1.1-1.1H14.6V1.13C14.6.5 15.1 0 15.7 0c.62 0 1.1.5 1.1 1.13V14.6h13.5c.6 0 1.1.5 1.1 1.1 0 .63-.5 1.14-1.1 1.14H16.8v13.48c0 .62-.48 1.12-1.1 1.12-.62 0-1.13-.5-1.13-1.12V16.84H1.1z\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/icons/plus.svg
// module id = ./src/icons/plus.svg
// module chunks = 21